import { SCANNER_ETF_CORE } from "./scannerUniverse.js";

const ETF_SET = new Set(SCANNER_ETF_CORE.map((s) => s.toUpperCase()));

/** Equities have earnings; sector/index ETFs and spot crypto do not. */
export function isEarningsEquity(symbol) {
  const sym = String(symbol || "").toUpperCase();
  if (!sym || sym.endsWith("-USD")) return false;
  if (ETF_SET.has(sym)) return false;
  return true;
}
